module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-common"><div class="notSub sma"><p>请订阅后再参与抽奖，据说手气更旺！</p><div class="btn"><a href="javascript:void(0)" onclick="lottery.sub(true);" class="close closeSub">订阅并抽奖</a></div></div></div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./modules/mask/not.sub.html
// module id = 28
// module chunks = 0